export const HOME_URL = "/";
export const PRICING_URL = `${HOME_URL}pricing`
export const DEVELOPER_TOOLS_URL = `${HOME_URL}developer-tools`

export const LOGIN_URL = `${HOME_URL}login`